import { List } from "immutable";

import SessionFinishedEvent from "seneca-common/features/session/models/SessionFinishedEvent";

import actionTypes from "../../../../action-types";
import {
  RecentlyStudiedCourse,
  UserStat,
  UserStatServerType
} from "../../../../models/state/userStats";
import transformServerSessionDuration from "../../../../utils/transformServerSessionDuration";
import transformServerTimestamp from "../../../../utils/transformServerTimestamp";

export const userStats = (
  userStat: UserStat = new UserStat(),
  action: Record<string, any>
) => {
  switch (action.type) {
    case actionTypes.COMPLETE_SESSION:
      return applyCompleteSessionEventToUserStat(userStat, action.payload);

    case actionTypes.RECEIVE_USER_STUDY_STATS:
      return transformServerUserStat(action.payload.userStudyStats);

    case actionTypes.RECEIVE_RECONCILED_USER_STUDY_STATS:
      return action.payload.userStudyStats;

    default:
      return userStat;
  }
};

export const applyCompleteSessionEventToUserStat = (
  userStat: UserStat,
  {
    courseId,
    timeFinished,
    modulesStudied,
    totalModulesStudyTime
  }: SessionFinishedEvent
) =>
  userStat
    .update("sessionsCompleted", count => count + 1)
    .set("lastStudied", timeFinished!)
    .update(
      "totalStudyTime",
      totalStudyTime => totalStudyTime + totalModulesStudyTime
    )
    .update("sessionModulesStudied", count => count + modulesStudied)
    .update("recentlyStudiedCourses", recentlyStudiedCourses =>
      updateRecentlyStudiedCourses(
        recentlyStudiedCourses,
        courseId!,
        timeFinished!
      )
    );

const updateRecentlyStudiedCourses = (
  recentlyStudiedCourses: List<RecentlyStudiedCourse>,
  courseId: string,
  timeFinished: string
) =>
  recentlyStudiedCourses
    .filter(
      recentlyStudiedCourse => recentlyStudiedCourse.courseId !== courseId
    )
    .insert(
      0,
      new RecentlyStudiedCourse({
        courseId,
        studiedDate: timeFinished
      })
    );

export const transformServerUserStat = (
  serverUserStat: UserStatServerType
): UserStat =>
  new UserStat({
    ...serverUserStat,
    totalStudyTime: transformServerSessionDuration(
      serverUserStat.totalStudyTime
    ),
    lastStudied: transformServerTimestamp(serverUserStat.lastStudied),
    recentlyStudiedCourses: List(
      serverUserStat.recentlyStudiedCourses.map(
        ({ courseId, studiedDate }) =>
          new RecentlyStudiedCourse({
            courseId,
            // @ts-ignore
            studiedDate: transformServerTimestamp(studiedDate)
          })
      )
    )
  });
